<ng-container>
  <input *ngIf="field_type_id==='' || field_type_id===null || field_type_id===undefined" [(ngModel)]="value" type="text"
    class="form-control font-bold" (blur)="onBlur()" (keyup)="onBlur()" [disabled]="disabled">

  <app-text-editor *ngIf="field_type_id===1 || field_type_id===2" [metadata]="selectedMetadata" [showCancel]="false"
    [updateBtnText]="'Update Text'"
    [fieldValue]="selectedMetadata?.metadata_value_html ? selectedMetadata?.metadata_value_html : selectedMetadata?.metadata_value"
    (updateField)="updateFieldFromEditor($event);">
  </app-text-editor>
  <select *ngIf="field_type_id===3" [(ngModel)]="value" class="custom-select" (change)="onBlur()" [disabled]="disabled">
    <option [ngValue]="val" *ngFor="let val of selectedMetadata?.field_possible_values">{{ val }}</option>
  </select>
  <div class="date-picker" *ngIf="field_type_id===4" [attr.disabled]="disabled">
    <my-date-picker [(ngModel)]="value" [options]="myDatePickerOptionsStartDate" (blur)="onBlur()"
      (dateChanged)="onCustomDateChanged($event)"></my-date-picker>
  </div>
  <input class="form-control font-bold" (blur)="onBlur()" (keyup)="onBlur()" [(ngModel)]="value" value="{{value}}"
    *ngIf="field_type_id===5" type="text" [disabled]="disabled" atp-time-picker />
  <input *ngIf="field_type_id===6" [(ngModel)]="value" type="text" (keypress)="isNumber($event)"
    class="form-control font-bold" (blur)="onBlur()" (keyup)="onBlur()"
    [attr.aria-label]="'Please enter '+selectedMetadata?.name" [disabled]="disabled">
</ng-container>
